// Set a cookie
export const setCookie = function (name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value || "")}${expires}; path=/`;
};
// Get a cookie by name
export const getCookie = function (name) {
    const nameEQ = encodeURIComponent(name) + "=";
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
        while (cookie.charAt(0) === ' ')
            cookie = cookie.substring(1);
        if (cookie.indexOf(nameEQ) === 0)
            return decodeURIComponent(cookie.substring(nameEQ.length));
    }
    return null;
};
// Delete a cookie
export const deleteCookie = function (name) {
    document.cookie = `${encodeURIComponent(name)}=; Max-Age=-99999999; path=/`;
};
